<mat-form-field [appearance]="appearance" class="fk-w-full">
  <!-- label -->
  <mat-label>
    <base-form-kit-label [label]="label">
      <ng-content select="[label-content]"></ng-content>
    </base-form-kit-label>
  </mat-label>

  <mat-select
    #matSelect
    panelClass="fk-dir-ltr"
    [(ngModel)]="value"
    [matTooltip]="isAddTooltipToMatSelect ? getSelectedItemTitle() : ''"
    (selectionChange)="emitValue(value)"
    [formControl]="control || defaultControl"
  >
    <mat-option>
      <ngx-mat-select-search
        class="fk-dir-rtl"
        [formControl]="filterControl"
        [placeholderLabel]="placeholder | translate"
        [noEntriesFoundLabel]="'common.empty' | translate"
      >
        <div ngxMatSelectSearchClear class="fk-text-2xl">×</div>
      </ngx-mat-select-search>
    </mat-option>

    <mat-option
      class="select-search-option"
      #matOption
      *ngFor="let item of filteredItems | async"
      [value]="item[optionValue]"
      (onSelectionChange)="emitItem(item, $event)"
      [matTooltip]="
        onCheckAddTooltipToOption(matOption) ? item[optionTitle] : ''
      "
    >
      <span
        class="fk-tracking-normal fk-text-sm"
        [innerHTML]="item[optionTitle]"
      ></span>
    </mat-option>
    <mat-option class="fk-dir-rtl" *ngIf="this.items?.length == 0">
      <span class="fk-tracking-normal fk-text-sm">
        {{ "common.empty" | translate }}
      </span>
    </mat-option>
  </mat-select>

  <div class="fk-flex-center fk-px-2" matSuffix>
    <!-- init loading -->
    <mat-icon
      class="fk-text-primary fk-flex-around fk-h-full"
      *ngIf="loading && !isDisabled"
    >
      <span
        class="fk-spinner-border fk-spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="sr-only">Loading...</span>
    </mat-icon>

    <!-- refresh btn -->
    <mat-icon
      class="fk-text-blue"
      [matTooltip]="'common.refresh' | translate"
      *ngIf="!isDisabled && !initLoading && isShowRefreshBtn"
      (click)="refresh()"
    >
      refresh
    </mat-icon>

    <!-- clear btn -->
    <mat-icon
      class="fk-text-gray fk-cursor-pointer"
      [matTooltip]="'common.delete' | translate"
      *ngIf="
        this.value != null &&
        !isDisabled &&
        !initLoading &&
        removable &&
        items?.length
      "
      (click)="clear()"
    >
      delete_forever
    </mat-icon>

    <validation-icon
      [control]="control"
      [hasMatPrefix]="hasMatPrefix"
      [hasMatSuffix]="hasMatSuffix"
      [value]="value"
      [isShowValidationStatusIcon]="isShowValidationStatusIcon"
    >
    </validation-icon>
  </div>

  <!-- prefix content -->
  <div
    matPrefix
    class="fk-mx-2 fk-relative"
    [style.display]="hasMatPrefix ? 'block' : 'none'"
  >
    <div #prefixContent>
      <ng-content select="[prefix-content]"></ng-content>
    </div>
  </div>
</mat-form-field>
